import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=43ec2017"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports